import { render, staticRenderFns } from "./TagIconNew.vue?vue&type=template&id=5966e6b2"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5966e6b2')) {
      api.createRecord('5966e6b2', component.options)
    } else {
      api.reload('5966e6b2', component.options)
    }
    module.hot.accept("./TagIconNew.vue?vue&type=template&id=5966e6b2", function () {
      api.rerender('5966e6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/TagIconNew.vue"
export default component.exports